import { render } from "./Dimension.vue?vue&type=template&id=2ca97676&scoped=true"
import script from "./Dimension.vue?vue&type=script&lang=js"
export * from "./Dimension.vue?vue&type=script&lang=js"

import "./Dimension.vue?vue&type=style&index=0&id=2ca97676&scoped=true&lang=css"

import exportComponent from "/home/runner/work/adx-front-end/adx-front-end/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2ca97676"],['__file',"src/views/report/Dimension.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "2ca97676"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('2ca97676', __exports__)) {
    api.reload('2ca97676', __exports__)
  }
  
  module.hot.accept("./Dimension.vue?vue&type=template&id=2ca97676&scoped=true", () => {
    api.rerender('2ca97676', render)
  })

}


export default __exports__